<div class="form-floating" [style]="inputStyle">
  <input
    type="date"
    class="form-control shadow-none"
    [formControl]="control"
    [min]="min"
    [max]="max"
    [id]="inputId"
    (change)="onChanged($event)"
    onkeydown="return false"
    *ngIf="!(withHour || timeOnly)"
  />
  <input
    type="datetime-local"
    class="form-control shadow-none"
    [formControl]="control"
    [min]="min"
    [max]="max"
    [id]="inputId"
    (change)="onChanged($event)"
    onkeydown="return false"
    *ngIf="withHour"
  />
  <input
    type="time"
    class="form-control shadow-none"
    [formControl]="control"
    [id]="inputId"
    (change)="onChanged($event)"
    onkeydown="return false"
    *ngIf="timeOnly"
  />
  <label [for]="inputId">{{ label }}</label>
  <div
    class="error-message"
    *ngIf="
      control.invalid &&
      control.touched &&
      control.errors">
    {{ getErrorMessage() | translate }}
  </div>
</div>
